__turbopack_context__.v({
  "assetLeft": "index-module__xkfyRW__assetLeft",
  "assetRight": "index-module__xkfyRW__assetRight",
  "marquee": "index-module__xkfyRW__marquee",
  "marqueeContainer": "index-module__xkfyRW__marqueeContainer",
  "marqueeContent": "index-module__xkfyRW__marqueeContent",
});
